import fmeaImage from '@/assets/fmea_agent_image.jpg';
import forcedIdeationImage from '@/assets/forced_ideation_welcome.png';
import marketSizingImage from '@/assets/market_sizing_welcome.png';
import patentFtoImage from '@/assets/patent_fto_top_image.png';
import techExplorationImage from '@/assets/tech_exploration_top_image.png';
import {
  AGENT_NAME_FMEA,
  AGENT_NAME_FORCED_IDEATION,
  AGENT_NAME_MARKET_SIZING,
  AGENT_NAME_PATENT_FTO,
  AGENT_NAME_TECH_EXPLORATION,
  AGENT_TOP_ROUTE_NAME_FMEA,
  AGENT_TOP_ROUTE_NAME_FORCED_IDEATION,
  AGENT_TOP_ROUTE_NAME_MARKET_SIZING,
  AGENT_TOP_ROUTE_NAME_PATENT_FTO,
  AGENT_TOP_ROUTE_NAME_TECH_EXPLORATION,
} from '@/constants';
import { FunctionKey } from '@/types';
import { featureFlags } from '@/featureFlags';

/** 情報収集を使えるユーザーには選択画面を出さないため、情報収集は選択肢に含めない。 */
type SelectableAgentKey = Exclude<FunctionKey, 'information_retrieval'>;

export type AgentIntroduction = {
  key: SelectableAgentKey;
  name: string;
  topRouteName: string;
  image: string;
  catchphrase: string;
  description: string;
};

// キーが増えたときに紹介文の追加漏れを型で落とすため、Recordで持つ
const INTRODUCTIONS: Record<SelectableAgentKey, AgentIntroduction> = {
  tech_exploration: {
    key: 'tech_exploration',
    name: AGENT_NAME_TECH_EXPLORATION,
    topRouteName: AGENT_TOP_ROUTE_NAME_TECH_EXPLORATION,
    image: techExplorationImage,
    catchphrase: '解決策調査の抜け漏れをなくしたい',
    description:
      '課題を要因仮説から解決策までツリー構造で整理し、関連文献で客観性も担保します。',
  },
  patent_fto: {
    key: 'patent_fto',
    name: AGENT_NAME_PATENT_FTO,
    topRouteName: AGENT_TOP_ROUTE_NAME_PATENT_FTO,
    image: patentFtoImage,
    catchphrase: '特許調査の負荷を軽減したい',
    description:
      '特許文献を自動解析し、開発中の技術との一致度を直感的に把握できます。',
  },
  forced_ideation: {
    key: 'forced_ideation',
    name: AGENT_NAME_FORCED_IDEATION,
    topRouteName: AGENT_TOP_ROUTE_NAME_FORCED_IDEATION,
    image: forcedIdeationImage,
    catchphrase: '自社技術の新たな活用先を見出したい',
    description:
      '市場ニーズと技術シーズを掛け合わせ、新たな事業機会の発掘を支援します。',
  },
  market_sizing: {
    key: 'market_sizing',
    name: AGENT_NAME_MARKET_SIZING,
    topRouteName: AGENT_TOP_ROUTE_NAME_MARKET_SIZING,
    image: marketSizingImage,
    catchphrase: '市場規模を根拠をもって説明したい',
    description:
      'コンサルタントの思考プロセスを再現したフェルミ推定で説得力ある数字を算出します。',
  },
  fmea: {
    key: 'fmea',
    name: AGENT_NAME_FMEA,
    topRouteName: AGENT_TOP_ROUTE_NAME_FMEA,
    image: fmeaImage,
    catchphrase: '故障モードの抜け漏れをなくしたい',
    description:
      '設計資料をもとに故障モードと影響・原因の候補を網羅的に洗い出し、対策案まで提示します。',
  },
};

export const AGENT_INTRODUCTIONS: AgentIntroduction[] = [
  INTRODUCTIONS.tech_exploration,
  INTRODUCTIONS.patent_fto,
  ...(featureFlags.ANDEV_9078_FORCED_IDEATION
    ? [INTRODUCTIONS.forced_ideation]
    : []),
  ...(featureFlags.ANDEV_9479_MARKET_SIZING
    ? [INTRODUCTIONS.market_sizing]
    : []),
  ...(featureFlags.ANDEV_10285_FMEA ? [INTRODUCTIONS.fmea] : []),
];
